/* ============================================================
   TRADIE — Mixed colours: swatch "added" click feedback
   Pairs with colour-mixer-swatch-feedback.css.

   assets/pf-custom.js's PfColorMixer.addProductToBundle() fills the
   next empty .pf-colmix-tile when you click a .pf-colmix-btn swatch
   — but does nothing at all (no error, no feedback) if the bundle
   is already full, since the fill loop just breaks without a match.
   Confirms the tap actually worked by comparing how many tiles are
   filled immediately before vs. after the click, and only pulses
   the swatch when that count actually went up.

   Uses a capture-phase listener to snapshot the "before" count.
   PfColorMixer's own click handler is registered directly on the
   slider wrapper (an ancestor of the swatch button, not document),
   so by the time a normal bubble-phase document listener would run,
   that handler has already fired and mutated the tiles. A
   capture-phase listener on document runs top-down before any
   bubble-phase handler, so it reads the true pre-click state.
   ============================================================ */

(function () {
  function countFilledTiles() {
    return document.querySelectorAll('.pf-colmix-tile:not(:has(.pf-colmix-empty))').length;
  }

  let beforeCount = 0;

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.pf-colmix-btn')) return;
    beforeCount = countFilledTiles();
  }, true);

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.pf-colmix-btn');
    if (!btn) return;

    const afterCount = countFilledTiles();
    if (afterCount <= beforeCount) return;

    btn.classList.remove('pf-colmix-btn--added');
    void btn.offsetWidth; // restart the animation if clicked again quickly
    btn.classList.add('pf-colmix-btn--added');

    setTimeout(function () {
      btn.classList.remove('pf-colmix-btn--added');
    }, 450);
  }, false);
})();
